
/***************** SLIDER ******************/  
if ($('.bd-slider').length) {
    $('.bd-slider').each(function () {
      var slider = $(this);
  
      var arrows = (slider.data('arrows')) ? slider.data('arrows') : false;
      var dots = (slider.data('dots')) ? slider.data('dots') : false;
      var adaptiveHeight = (slider.data('adaptive-height')) ? slider.data('adaptive-height') : false;
      var navfor = (slider.data('nav-for')) ? slider.data('nav-for') : false;
      var freeScroll = (slider.data('free-scroll')) ? slider.data('free-scroll') : false;
      var wrapAround = (slider.data('wrap-around')) ? slider.data('wrap-around') : false;
      var initialIndex = (slider.data('initial-index')) ? slider.data('initial-index') : 0;
      var cellAlign = (slider.data('cell-align')) ? slider.data('cell-align') : 'left';
      var autoPlay = (slider.data('autoplay')) ? slider.data('autoplay') : 0;
      var watchCSS = (slider.data('watch-css')) ? slider.data('watch-css') : false;
  
      // console.log(slider.data('arrows'));
  
      slider.flickity({
        groupCells: true,
        contain: true,
        percentPosition: false,
        prevNextButtons: arrows,
        pageDots: dots,
        adaptiveHeight: adaptiveHeight,
        asNavFor: navfor,
        freeScroll: freeScroll,
        wrapAround: wrapAround,
        initialIndex: initialIndex,
        autoPlay: autoPlay,
        cellAlign: cellAlign,
        watchCSS: watchCSS,
        on: {
          ready: function () {
            console.log('ready slider');
          }
        }
      });
  
      // FOR CUSTOM PAGINATION
      if (slider.data('custom-pag')) {
        var target = slider.data('custom-pag');
        // previous
        $('[data-pag-target="' + target + '"] .prev-arrow').on('click', function () {
          slider.flickity('previous', true);
         // // console.log('prev');
        });
        // next
        $('[data-pag-target="' + target + '"] .next-arrow').on('click', function () {
          slider.flickity('next', true);
         // // console.log('next');
        });
  
        function updateStatus() {
          var cellNumber = slider.flickity().data('flickity').selectedIndex + 1; 
             //// console.log( cellNumber + '/' + slider.data('flickity').slides.length ); 
          if (cellNumber == 1) {
            $('[data-pag-target="' + target + '"] .prev-arrow').addClass('disabled');
          } else {
            $('[data-pag-target="' + target + '"] .prev-arrow').removeClass('disabled');
          }
          if (cellNumber == slider.data('flickity').slides.length) {
            $('[data-pag-target="' + target + '"] .next-arrow').addClass('disabled');
          } else {
            $('[data-pag-target="' + target + '"] .next-arrow').removeClass('disabled');
          }
        }
        updateStatus();
        updatePagNames(0);

        function updatePagNames(index) {

           console.log(index,'UpdateNames');
            const target = slider.data('custom-pag');
            const size = parseInt(slider.data('flickity').slides.length);
            // console.log('Slide Length', size);
            //var currentSlide = $('[data-index="'+index+'"]', slider); 
            var nextSlide = $(`[data-index="${index + 1}"]`, slider); 
            var prevSlide = $(`[data-index="${index - 1}"]`, slider); 
            if(index < (size - 1)) { 
                // console.log('currentIndex', index);
            } else {
            nextSlide = $('[data-index="0"]', slider);
            // console.log('Next Slide is First Slide');
            } 
            if(index > 0) { 
            // console.log('we have previous slides');
                } else {
                prevSlide = $('[data-index="'+(size - 1)+'"]', slider);
                // console.log('Previous Slide is Last Slide');
                }

                 // console.log('nextSlide', nextSlide);
                // console.log('prevSlide', prevSlide);

                var nextTitle = nextSlide.data('title');
                var prevTitle = prevSlide.data('title');

                // console.log('nextTitle', nextTitle);
                // console.log('prevTitle', prevTitle);
                $('[data-pag-target="' + target + '"] [data-next-text]').html(nextTitle);
                $('[data-pag-target="' + target + '"] [data-prev-text]').html(prevTitle); 
         
        }

        /* BREAKS CAROUSEL not sure its needed
        slider.flickity().on('change.flickity', function(event, index) {
          updatePagNames(index);
          updateStatus();
      }); 
      */ 
      }
      // END CUSTOM PAGINATION
 

    }); // END EACH
  
  }